module.exports = __webpack_public_path__ + "static/blog-a2703ec418cf4a3d23562b0e9172952f.jpg";